import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { bindTelegramBackButton } from "../lib/telegram";
import { DesktopSidebar } from "./DesktopSidebar";
import { MobileNavigation } from "./MobileNavigation";
import { SocialLinks } from "./SocialLinks";
import { ThemeSwitcher } from "./ThemeSwitcher";

export function AppLayout() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === "/") return;
    return bindTelegramBackButton(() => navigate(-1));
  }, [location.pathname, navigate]);

  useEffect(() => {
    const targetId = location.hash.slice(1);
    window.requestAnimationFrame(() => {
      if (targetId) document.getElementById(targetId)?.scrollIntoView({ behavior: "smooth", block: "start" });
      else window.scrollTo({ top: 0, behavior: "instant" });
    });
  }, [location.pathname, location.hash]);

  return (
    <div className="app-shell">
      <DesktopSidebar />
      <main className="main-content">
        <ThemeSwitcher variant="floating" />
        <Outlet />
        <footer className="app-footer">
          <div className="app-footer__channels">
            <strong>Официальные каналы Social</strong>
            <SocialLinks compact />
          </div>
          <p>Внутренний информационный ресурс. Перед публикацией данных проверяйте статус и источник.</p>
        </footer>
      </main>
      <MobileNavigation />
    </div>
  );
}
